import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { ProfileComponent } from '../../shared/components/profile/profile.component';

@Component({
  selector: 'app-consumer-profile',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    PageHeaderComponent,
    ProfileComponent,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ConsumerProfileComponent {}
